import AboutCountCard from "./AboutCountCard";

const AboutOverview = () => {
  const countData = [
    {
      text: "Customers",
      count: "300",
    },
    {
      text: "Projects Finished",
      count: "78",
    },
    {
      text: "Employees",
      count: "95",
    },
  ];
  return (
    <div className="bg-gradient-to-b from-slate-50 to-slate-300 min-h-[400px] mt-4 lg:px-20 sm:px-10 px-4 py-4 relative">
      <div className="flex items-center lg:justify-around md:justify-between justify-center lg:flex-row flex-col-reverse min-h-[400px]">
        <div className="xl:max-w-[500px] lg:max-w-[420px] md:max-w-[80%]">
          <h1 className="md:text-6xl sm:text-5xl text-4xl md:mt-0 mt-3  font-bold">Content Has to Be More That Just Brilliant</h1>
          <p className="mt-2 text-gray-500 text-lg">
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Amet sed
            nam nemo magni quo a dignissimos sapiente odio, soluta qui?
          </p>
        </div>
        <div className="grid sm:grid-cols-2 grid-cols-1">
          {countData.map((count) => {
            return <AboutCountCard text={count.text} count={count.count} />;
          })}
        </div>
      </div>
    </div>
  );
};
export default AboutOverview;
